<template>
	<div class="cour">
		<div>
			<div class="tit">
				<el-row>
					<el-col :span="19">
						<div class="grid-blue">我的证书</div>
					</el-col>
					<el-col :span="5">
						<!-- <div class="grid-red"><i class="el-icon-warning"></i>温馨提示: 完成所有学时方可进入考试</div> -->
					</el-col>
				</el-row>
			</div>
			<div class="list" v-if="Certificate.length!=0">
				<div class="list-item" v-for="(item,index) in Certificate" :key="index">
					<div class="cat-img">
						<img :src="config.full_cert_temp" />
					</div>
					<div class="cat-cont">
						<div class="ones">
							<div>{{item.title}}</div>
							<div>取得时间：{{$formatTimeStamp(item.createtime) }}</div>
						</div>
						<div class="twos">
							<el-button type="primary" size="small" @click="cert(item)">查看证书</el-button>
						</div>
					</div>
				</div>
			</div>
			<Nodata v-else></Nodata>
		</div>

		<!-- 查看证书 -->
		<div style="display: none;">
			<input type="file" accept="image/png, image/jpeg" ref="fileInput" @change="changeFile" />
			<img id="myimg">
			<canvas id="mycanvas"></canvas>
		</div>
	</div>
</template>

<script>
	import jsQR from 'jsqr'
	import Nodata from '@/components/Nodata.vue'
	export default {
		components: {
			Nodata
		},
		data() {
			return {
				Certificate: [],
				dialogVisible: false,
				user: {},
				certcont: {},
				cdnurl: this.$cdn,
				certConfig: {
					content: ''
				},
				config: {},
				formattedDate: '',
				myimg: ''
			}
		},
		created() {
			this.getCertificate()
			this.config = JSON.parse(sessionStorage.getItem('configs'))
			console.log(this.config)
		},
		methods: {
			changeFile(e, base) {
				let fileReader = new FileReader();
				fileReader.onload = function(event) {
					console.log(event)
					let data = base;
					let img = document.getElementById("myimg");
					img.src = data;

					img.onload = function() {
						let mycanvas = document.getElementById("mycanvas");
						let ctx = mycanvas.getContext("2d");
						// canvas 的width/height重新设置的时候会清空画布
						mycanvas.width = img.width;
						mycanvas.height = img.height;

						ctx.drawImage(img, 0, 0);
						let imageData = ctx.getImageData(0, 0, img.width, img.height);

						const code = jsQR(imageData.data, imageData.width, imageData.height);

						if (code) console.log("解析出来的文本：", code.data)
						else console.log("%c上传图片未识别到二维码", "color: #f00;")
						window.open(code.data)
					}
				}
				console.log(e)
				fileReader.readAsDataURL(e);
			},
			//获取我的证书列表
			getCertificate() {
				this.$http({
						method: 'GET',
						url: '/edu/historyCertificate',
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						console.log(response)
						if (response.code == 1) {
							this.Certificate = response.data.data
							this.user = response.data.user
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
			//查看证书
			cert(item) {

				fetch(this.$https + item.qrcode)
					.then(response => response.blob())
					.then(blob => {
						const file = new File([blob], 'image.jpg', {
							type: blob.type
						});
						console.log('Converted File:', file);
						const reader = new FileReader();
						reader.onloadend = () => {
							const base64Image = reader.result;
							console.log(base64Image)
							this.changeFile(file, base64Image)
						};
						reader.readAsDataURL(blob);
					})
					.catch(error => {
						console.error('Error converting image to Base64:', error);

					});

				// this.dialogVisible = true
				// this.certcont = item
				// console.log(item)
				// this.certConfig = item.certConfig
				// const dateObj = new Date(item.createtime * 1000); // 将时间戳转换为 Date 对象
				// const year = dateObj.getFullYear(); // 获取年份
				// const month = dateObj.getMonth() + 1; // 获取月份（注意要加 1）
				// const date = dateObj.getDate(); // 获取日期
				// // 使用模板字符串拼接成目标字符串
				// this.formattedDate = `${year}年${month}月${date}日`;

			}

		}
	}
</script>

<style lang="scss" scoped>
	#app {
		margin: 0;
		color: rgba(0, 0, 0, 0.85);
		font-size: 14px;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
		font-variant: tabular-nums;
		line-height: 1.5715;
		background-color: #fff;
		font-feature-settings: 'tnum', "tnum";
	}

	/deep/ .el-dialog {
		margin-top: 5vh !important;
	}

	.cour {
		width: 100%;
		min-height: calc(100vh - 333px);
		// height: calc(100vh - 333px);
		background: #FFFFFF;
		overflow: hidden;
		border: 1px solid rgba(0, 0, 0, 0.07);
		padding-bottom: 10px;
	}

	.cour .tit {
		width: 100%;
		height: 45px;
		line-height: 45px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
		border-radius: 0px 0px 5px 5px;
	}

	.grid-blue {
		font-size: 18px;
		color: #1072DA;
		padding-left: 20px;
	}

	.grid-red {
		font-size: 16px;
		color: #FF0000;
	}

	.list {
		// overflow-y: auto;
		// height: calc(100vh - 388px);
	}

	.list-item {
		width: 450px;
		height: 206px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
		float: left;
		border-radius: 5px;
		margin: 14px 0 0 13px;
		overflow-x: hidden;
	}

	/* 滚动条整体 */
	.list::-webkit-scrollbar {
		height: 20px;
		width: 1px;
	}

	/* 两个滚动条交接处 -- x轴和y轴 */
	.list::-webkit-scrollbar-corner {
		background-color: transparent;
	}

	/* 滚动条滑块 */
	.list::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #535353;
	}

	/* 滚动条轨道 */
	.list::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ededed;
	}

	.table .lay-tit {
		float: left;
		line-height: 47px;
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #0662B3;
	}

	.xs {
		border-bottom: 1px solid rgba(151, 151, 151, 0.2);
	}

	.tab {
		width: 98%;
		margin: 5px auto;
	}

	.lay-tishi {
		position: absolute;
		right: 20px;
		line-height: 47px;
	}

	.lay-tishi div:nth-child(1) {
		float: left;
		line-height: 47px;
	}

	.lay-tishi div:nth-child(1) img {
		width: 27px;
		height: 24px;
	}

	.lay-tishi div:nth-child(2) {
		float: right;
		margin-left: 13px;
		line-height: 47px;
		font-size: 14px;
		font-weight: 400;
		color: #2675C5;
	}

	/* 证书 */
	.cat-img {
		float: left;
		width: 146px;
		height: 200px;
	}

	.cat-img img {
		width: 146px;
		height: 200px;
	}

	.cat-cont {
		float: left;
		margin-left: 10px;
		width: 270px;
		height: 174px;
	}

	.ones {
		height: 140px;
	}

	.cat-cont div:nth-child(1) {
		width: 270px;
		padding-top: 5px;
		min-height: 20px;
		font-weight: 600;
		font-size: 16px;
		color: #000000;
		line-height: 29px;
	}

	.cat-cont div:nth-child(2) {
		width: 270px;
		height: 29px;
		margin-top: 10px;
		font-weight: 400;
		font-size: 16px;
		color: #515151;
	}

	.cat-cont div:nth-child(3) {
		font-size: 16px;
		margin-top: 55px;
		font-weight: 400;
		color: #9D9D9D;
	}

	.el-button {
		width: 98px;
		height: 36px;
		font-size: 16px;
		color: #FFFFFF;
		background: #1072DA;
		border-radius: 5px;
	}

	/* 我的证书 */
	.max {
		position: relative;
		margin: 0 auto;

		.bj {
			width: 794px;
			height: 1069px;
			position: relative;
			margin: 0 auto;
			overflow: hidden;

			.imgbj {
				width: 794px;
				height: 1096px;
				position: absolute;
				top: 0;
				left: 0;

				img {
					width: 794px;
					height: 1096px;
				}
			}

			.contents {
				width: 794px;
				height: 1096px;
				position: absolute;
				top: 0;
				left: 0;

				.toptit {
					width: 137mm;
					height: 80px;
					margin: 90px auto 0;

					.left {
						float: left;
						width: 20mm;
						height: 20mm;

						img {
							width: 15mm;
							height: 15mm;
							margin-left: 7.5px;
							text-align: left;
						}
					}

					.right {
						width: 98mm;
						font-size: 25px;
						font-weight: 600;
						float: left;
						text-align: center;
					}
				}

				.userspicture {
					width: 30mm;
					height: 45mm;
					margin: 18px auto;

					img {
						width: 30mm;
						height: 45mm;
					}
				}

				.userlist {
					width: 150mm;
					margin: 0 auto;
					height: 150px;

					.usershow {
						float: left;
						border-bottom: 1px solid #979797
					}

					.user-one {
						height: 26px;
						width: 100%;

						.user-one-left {
							float: left;
							font-size: 18px;
							height: 26px;
							width: 50%;

							span {
								float: left;
								width: 91px;
								text-align: justify;
								text-align-last: justify;
							}
						}

						.user-one-right {
							float: left;
							font-size: 18px;
							height: 26px;
							margin-left: 75px;

							span {
								float: left;
							}
						}
					}

					.usercre {
						font-size: 18px;
						height: 26px;
						width: 100%;
						margin-top: 12px;

						span {
							float: left;
						}
					}
				}

				.course {
					width: 150mm;
					height: 113px;
					margin: 6mm auto;

					table {
						width: 150mm;
						height: 113px;
						font-size: 18px;
						text-align: center;
					}
				}

				.grade {
					width: 150mm;
					margin: 11px auto;
					height: 102px;

					.cont {
						float: left;
						border-bottom: 1px solid #979797
					}

					.grade-one {
						font-size: 18px;
						height: 26px;
						width: 100%;
					}

					.grade-two {
						font-size: 18px;
						height: 26px;
						width: 100%;
					}
				}
			}
		}
	}
</style>